<template>
    <div class="activity-log">
        <b-card no-body>
            <b-card-header class="p-3">
                <b-row align-v="center">
                    <b-col>
                        <h3 class="mb-0">
                            Activity Log
                        </h3>
                    </b-col>
                    <b-col cols="4">
                        <el-date-picker
                        v-model="date_picked"
                        type="date"
                        value-format="yyyy-MM-dd"
                        class="float-right py-0"
                        placeholder="Pick a day"
                        @change="findActivityLogs">
                        </el-date-picker>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-row class="p-3" v-if="current_customer_logs.length > 0">
                <b-col 
                    cols="12" 
                    class="mb-3"
                    v-for="(log, index) in paginatedData"
                    :key="index"
                >
                    <div v-if="log.event === 'created'">
                        <p class="mb--1 font-weight-normal text-sm">
                            <span class="text-capitalize font-weight-600">{{ log.attribute}}</span> 
                            was {{ log.event }} by <span class="font-weight-600">{{ log.causer || 'N/A' }}</span>.
                        </p>
                        <small>{{ log.date | dateFormatString }}</small>
                    </div>
                    <div v-if="log.event === 'updated'">
                        <div v-if="log.new_value && !log.old_value">                       
                            <p class="mb--1 font-weight-normal text-sm">
                                <span class="text-capitalize font-weight-600">{{ log.attribute}}</span> 
                                was {{ log.event }} to <span  class="font-weight-600">{{ log.new_value }}</span> by <span class="font-weight-600">{{ log.causer || 'N/A' }}</span>.
                            </p>
                            <small>{{ log.date | dateFormatString }}</small>
                        </div>
                        <div v-if="log.new_value && log.old_value">                       
                            <p class="mb--1 font-weight-normal text-sm">
                                <span class="text-capitalize font-weight-600">{{ log.attribute}}</span> 
                                was {{ log.event }} from <span  class="font-weight-600">{{ log.old_value }}</span>  to <span  class="font-weight-600">{{ log.new_value }}</span> by <span class="font-weight-600">{{ log.causer || 'N/A' }}</span>.
                            </p>
                            <small>{{ log.date | dateFormatString }}</small>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12">
                    <el-pagination
                        class="float-right"
                        background
                        :current-page="currentPage"
                        :page-size=10
                        layout="prev, pager, next"
                        hide-on-single-page
                        :total=totalItems
                        @current-change="handlePageChange"
                        >
                    </el-pagination>
                </b-col>
            </b-row>
            <div v-else class="p-3">
                <span class="font-weight-bold text-sm">No record found.</span>
            </div>
        </b-card>
    </div>
</template>
<script>
import { DatePicker, Pagination } from 'element-ui'
import {
notifyFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'

    export default {
        props: ['customer'],
        mixins: [notifyFunctionMixin],
        components: {
            [DatePicker.name]: DatePicker,
            [Pagination.name]: Pagination,
        },
        data() {
            return {
                date_picked: '',
                label: {
                    'platform_id': 'Platform',
                    'source_channel_id': 'Channel',
                    'main_status': 'Main Status',
                    'sub_status': 'Sub Status',
                    'contact_no': 'Contact No',
                    'meeting_id': 'Meeting',
                    'meeting_status': 'Meeting Status',
                    'start_at': 'Start Date',
                    'end_at': 'End Date',
                    'subject': 'Title'
                },
                totalItems: 0,
                paginatedData: [],
                currentPage: 1,
                pageSize: 10,
            }
        },

        computed:{
            ...mapState(useCustomerStore, ['current_customer_logs']),
        },
        watch:{
            customer(newVal, oldVal){
                if(newVal){
                    this.getCustomerActivityLog(this.$route.params.customer_id)
                }
            },
            current_customer_logs(newVal) {
                if(newVal) {
                    this.currentPage = 1
                    this.totalItems = newVal.length
                    const startIndex = (this.currentPage - 1) * this.pageSize;
                    const endIndex = startIndex + this.pageSize;
                    this.paginatedData = newVal.slice(startIndex, endIndex)
                }
            }
        },
        async created(){
            await this.getCustomerActivityLog(this.$route.params.customer_id)
            this.totalItems = this.current_customer_logs.length
            this.updatePaginatedData();
        },
        methods:{
            ...mapActions(useCustomerStore,['getCustomerActivityLog']),
            findActivityLogs(){
                this.getCustomerActivityLog(this.$route.params.customer_id, this.date_picked)
            },
            updatePaginatedData() {
                const startIndex = (this.currentPage - 1) * this.pageSize;
                const endIndex = startIndex + this.pageSize;
                this.paginatedData = this.current_customer_logs.slice(startIndex, endIndex);
            },
            handlePageChange(page) {
                this.currentPage = page; // Update the current page when it changes
                this.updatePaginatedData();
                // this.fetchData(); // Fetch the data for the new page
            },
        }
    }
</script>